// extracted by mini-css-extract-plugin
export default {"favorite-text":"fxoIPFBJ6yXtgEUy137r"};